import React, { useContext } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import cls from './EstimateMeasurementsModalBody.module.css';
import { EstimateMainCalculation } from './EstimateMainCalculation/EstimateMainCulculation';
import { EstimateMeasurementDoors } from './EstimateMeasurementDoors/EstimateMeasurementDoors';
import { EstimateMeasurementWindow } from './EstimateMeasurementWindow/EstimateMeasurementWindow';
import { EstimateMeasurementsParameters } from './EstimateMeasurementsParameters/EstimateMeasurementsParameters';
import { EstimateMeasurementsContext } from '../../Context/EstimateMeasurementsContext';

export const EstimateMeasurementsModalBody = () => {
    const { comment } = useSelector((state) => state.measurementsReducer.calculations);
    const { imageList } = useContext(EstimateMeasurementsContext);
    return (
        <div
            className={classNames(cls.container, {
                [cls.CommentIsEmpty]: comment === '',
                [cls.ImageListNotEmpty]: imageList.length > 0 && comment === '',
            })}
        >
            <EstimateMainCalculation />
            <EstimateMeasurementDoors />
            <EstimateMeasurementWindow />
            <EstimateMeasurementsParameters />
        </div>
    );
};
